import { io, type Socket } from 'socket.io-client';
import { getAccessToken } from './apiClient';

// Single shared connection. The URL is same-origin in production (nginx proxies
// /socket.io) and proxied by Vite in dev.
let socket: Socket | null = null;

export function getSocket(): Socket {
  if (socket) return socket;
  socket = io({
    path: '/socket.io',
    autoConnect: false,
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10_000,
    auth: (cb) => cb({ token: getAccessToken() ?? '' }),
  });
  return socket;
}

export function connectSocket() {
  const s = getSocket();
  if (!s.connected) {
    // Refresh the token on each (re)connect attempt.
    s.auth = { token: getAccessToken() ?? '' };
    s.connect();
  }
}

export function disconnectSocket() {
  socket?.disconnect();
}
